import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Header component for the segments view that provides a UI affordance to create new segments.
 * This standalone component exposes an output event which notifies parent components when the user
 * requests creation of a new segment. It contains a simple imperative method to trigger that event.
 * No inputs are required; the parent controls what happens when a create action is emitted.
 * @component
 * @selector app-segments-header
 * @example
 *   <app-segments-header (createSegment)="onCreateSegmentRequested()"></app-segments-header>
 * @input none - This component does not accept any input properties.
 * @output EventEmitter<void> createSegment - Emitted when the user triggers the "create segment" action (for example by clicking a create button). The parent should handle this event to open a creation dialog or navigate to a creation view.
 * Key methods:
 *   - onCreateSegment(): void - Invokes createSegment.emit() to notify the parent that a create action was requested.
 * Lifecycle hooks:
 *   - This component does not implement Angular lifecycle hooks (e.g., ngOnInit) itself. Consumers can assume standard Angular lifecycle behavior and add hooks in parent components as needed.
 */
@Component({
  selector: 'app-segments-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './segments-header.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './segments-header.component.scss',
})
export class SegmentsHeaderComponent {
  @Output() createSegment = new EventEmitter<void>();

  onCreateSegment(): void {
    this.createSegment.emit();
  }
}
